import { StyleSheet, Text, View } from "react-native"
import { Colors } from "src/constants/Colors"
import { memo, useMemo, useState, useRef, useEffect } from "react"
import { BellIcon } from "src/components/parts/icons/BellIcon"
import dayjs from "dayjs"
import { ONE_DAY } from "src/recoil/hooks/resource/fileManager/common"
type Props = {
  timeLimitDate?: Date | string
}

export const TimeLimitLabel = memo<Props>(({ timeLimitDate }) => {
  // timeLimitDateをDate型に正規化
  const normalizedDate = useMemo(() => {
    if (!timeLimitDate) return null
    return timeLimitDate instanceof Date ? timeLimitDate : new Date(timeLimitDate)
  }, [timeLimitDate])

  const isLimitPassed = useMemo(() => {
    return normalizedDate ? normalizedDate < new Date() : false
  }, [normalizedDate])

  const [remainingTime, setRemainingMinutes] = useState<number | null>(
    normalizedDate ? Math.floor((normalizedDate.getTime() - new Date().getTime()) / 1000 / 60) : null
  )
  const intervalIdRef = useRef<any>()
  useEffect(() => {
    if (remainingTime && remainingTime > 0 && remainingTime < 60) {
      if (normalizedDate) {
        const intervalId = setInterval(() => {
          setRemainingMinutes((prevMinutes) => {
            if (prevMinutes === null || prevMinutes === 0) {
              clearInterval(intervalId)
              intervalIdRef.current = null
              return 0
            } else {
              return prevMinutes - 1
            }
          })
        }, 60000)
        intervalIdRef.current = intervalId
      } else {
        clearInterval(intervalIdRef.current)
        intervalIdRef.current = null
        setRemainingMinutes(0)
      }
    }
  }, [remainingTime, normalizedDate])
  if (!normalizedDate) return <></>

  return (
    <View style={styles.timeLimitLabelContainer}>
      <View style={styles.timeLimitLabelIconWrapper}>
        <BellIcon />
      </View>
      {!isLimitPassed ? (
        <Text style={styles.timeLimitLabel}>回答期限まであと{formatLimit(normalizedDate)}</Text>
      ) : (
        <Text style={styles.timeLimitLabel}>回答期限が過ぎています</Text>
      )}
    </View>
  )
})

const formatLimit = (timeLimitDate: Date) => {
  const timeLimitDayjs = dayjs(timeLimitDate)
  const nowDayjs = dayjs()
  const daysDiff = timeLimitDayjs.diff(nowDayjs, "day")
  if (daysDiff > 0) return `${daysDiff}日`
  const hoursDiff = timeLimitDayjs.diff(nowDayjs, "hour")
  if (hoursDiff > 0) return `${hoursDiff}時間`
  const minutesDiff = timeLimitDayjs.diff(nowDayjs, "minute")
  return `${minutesDiff}分`
}

const styles = StyleSheet.create({
  timeLimitLabelContainer: {
    paddingVertical: 2,
    paddingHorizontal: 10,
    borderRadius: 16,
    backgroundColor: Colors.leaf,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  timeLimitLabelIconWrapper: {
    width: 10,
    height: 10,
  },
  timeLimitLabel: {
    marginLeft: 4,
    fontSize: 12,
    color: Colors.white3,
  },
})
